import ContentGrid from "./ContentGrid";

export default ContentGrid;
